import React, { useEffect, useState } from "react";
import "./BusinessUnitOverrides.scss";
import CommissionRateHistoryTable from "./CommissionRateHistoryTable/CommissionRateHistoryTable";
import ICommissionRateHistory from "../../../interfaces/ICommissionRateHistory";
import ExpanderComponentProps from "react-data-table-component";
import BusinessUnitOverridesTable from "./BusinessUnitOverridesTable/BusinessUnitOverridesTable";
import { FAILED, IDLE, NEEDS_REFRESH } from "../../../redux/features/constants";
import {
  deliveryPartnerBusinessUnitOverrideSelector,
  fetchAllBusinessUnitsFCR,
  fetchBusinessUnitOverrides,
} from "../../../redux/features/deliveryPartnerSlice";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../redux/store/store";
import { fetchBusinessUnits } from "../../../redux/features/businessSlice";

// @ts-ignore
// prettier-ignore
const BusinessUnitOverrides: React.FC<ExpanderComponentProps<ICommissionRateHistory>
> = ({ data }) => {
  const businessUnitOverridesForPartner = useSelector(
    deliveryPartnerBusinessUnitOverrideSelector
  );

  const [errorMessage, setErrorMessage] = useState<string>("");
  const deliveryPartnersOverrideFetchError = useSelector(
    (state: RootState) => state.deliveryPartners.error
  );
  const deliveryPartnersOverrideReduxStatus = useSelector(
    (state: RootState) => state.deliveryPartners.deliveryPartnerStatus
  );
  const dispatch = useDispatch();

  // Keep business unit overrides in sync
  useEffect(() => {}, [businessUnitOverridesForPartner]);

  useEffect(() => {
    // @ts-ignore
    dispatch(fetchBusinessUnitOverrides(data.deliveryPartnerId));
    dispatch(fetchAllBusinessUnitsFCR());
    if (
      deliveryPartnersOverrideReduxStatus === IDLE ||
      deliveryPartnersOverrideReduxStatus === NEEDS_REFRESH
    ) {
      // @ts-ignore
      dispatch(fetchBusinessUnitOverrides(data.deliveryPartnerId));
    }
    if (deliveryPartnersOverrideReduxStatus === FAILED) {
      setErrorMessage(deliveryPartnersOverrideFetchError);
    }
  }, [
    dispatch,
    deliveryPartnersOverrideReduxStatus,
    deliveryPartnersOverrideFetchError,
    data.deliveryPartnerId,
  ]);

  return (
    <div key={data.deliveryPartnerId} className="BusinessUnitOverrides">
      <>
        <CommissionRateHistoryTable
          deliveryPartnerCommissionRateHistoryList={
            data.deliveryPartnerCommissionRateHistoryList
          }
          deliveryPartnerId={data.deliveryPartnerId}
          deliveryPartnerName={data.deliveryPartnerName}
          deliveryPartnerForm={data.deliveryPartnerForm}
          updateDeliveryPartners={data.updateDeliveryPartners}
        />
        <BusinessUnitOverridesTable
          deliveryPartnerBusinessUnitOverrides={businessUnitOverridesForPartner}
          deliveryPartnerId={data.deliveryPartnerId}
          deliveryPartnerName={data.deliveryPartnerName}
        />
      </>
    </div>
  );
};

export default BusinessUnitOverrides;
